import { render, staticRenderFns } from "./ekspedisi.vue?vue&type=template&id=1bf615fa"
import script from "./ekspedisi.vue?vue&type=script&lang=js"
export * from "./ekspedisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports